import Box from '@mui/material/Box';
import * as React from 'react';
import {useState} from 'react';
import {TabPanel} from '../../../components/other/tabPanel';
import {useTranslation} from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import {StyledTab, StyledTabs} from '../admin';
import {ConsultantPickerTest} from "./consultantPicker";

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: '#448FFF',
    },


}));

function TestPage(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const [tab, setTab] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <>
            <Box sx={{width: '100%'}}>
                <Box sx={{borderBottom: 1, borderColor: 'divider', display: 'flex'}}>
                    <StyledTabs
                        value={tab}
                        TabIndicatorProps={{className: classes.indicator}}
                        onChange={handleChangeTab}
                    >
                        <StyledTab value={0} label={t('Consultant merge NEW picker')}/>
                        <StyledTab value={1} label={t('test 2')}/>

                    </StyledTabs>
                </Box>

                <TabPanel value={tab} index={0}>
                    <div>Consultant Merge picker test</div>
                    <ConsultantPickerTest/>
                </TabPanel>

                <TabPanel value={tab} index={1}>
                    <span>test 2</span>
                </TabPanel>
            </Box>
        </>
    );
}

export default TestPage;